export function toKebabForDataCy(str: string = ''): string {
    const dataCyValue = String(str ?? '')
        .replace(/[[\]]/g, '')
        .trim();

    return dataCyValue
        .replace(/\./g, '-')
        .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
        .replace(/[_\s]+/g, '-')
        .replace(/[^a-zA-Z0-9-]/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '')
        .toLowerCase();
}
